import { render, staticRenderFns } from "./JomBantu.vue?vue&type=template&id=44edf6d6&"
import script from "./JomBantu.vue?vue&type=script&lang=js&"
export * from "./JomBantu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports